import React from "react";
import { Tooltip, tooltipClasses } from "@mui/material";
import BqnContext from "common/BqnContext";
import { useContext } from "react";
import styled from "styled-components";

const Label = styled.label`
  cursor: pointer;
`;

const TooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 5px;
`;

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip describeChild {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "white",
    color: "rgba(0, 0, 0, 0.7)",
    border: "1px solid rgba(0, 0, 0, 0.7)",
  },

  [`& .${tooltipClasses.tooltip} *`]: {
    color: "inherit",
  },
}));

export const BqnCell = ({ bqns = {} }) => {
  const { onlineBqns } = useContext(BqnContext);
  const values = Object.entries(bqns)
    .filter(([, value]) => value === true)
    .map(([bqnId]) => bqnId);

  const label =
    values.length === 0
      ? ""
      : values.length === onlineBqns.length
      ? "All"
      : "Not All";

  if (values.length === 1) {
    return <td> {values[0]} </td>;
  } else {
    return (
      <td>
        <HtmlTooltip
          title={
            <TooltipContent>
              {values.map((value) => (
                <label key={value}>BQN {value}</label>
              ))}
            </TooltipContent>
          }
          placement="left-start"
        >
          <Label>{label}</Label>
        </HtmlTooltip>
      </td>
    );
  }
};
